// actionLabels.js
export const FETCH_GRADE_REQUEST = 'FETCH_GRADE_REQUEST';
export const FETCH_GRADE_SUCCESS = 'FETCH_GRADE_SUCCESS';
export const FETCH_GRADE_FAILURE = 'FETCH_GRADE_FAILURE';
